import React from 'react'
import cn from 'classnames'

import config from '../config'
import styles from './ContactButton.module.css'

const ContactButton = ({ text, size }) => (
  <a href={config.messenger} className={cn(styles.message, styles[size])}>
    <span>{ text }</span>
  </a>
)

ContactButton.defaultProps = {
  text: 'Chat with us about apps',
  size: 'large',
}

export default ContactButton



// WEBPACK FOOTER //
// ./src/components/ContactButton.js